import React from "react";
import sortBy from "lodash/sortBy";
import isEqual from "lodash/isEqual";
import moment from "moment";
import { Dropdown, Menu, Icon } from "antd";

export const stringComparator = (a, b) => {
    const sorted = sortBy([a, b], [_ => _]);
    return isEqual(sorted, [a, b]) ? 1 : -1;
};

export const dateComparator = (a, b) => {
    if (!a) {
        return -1;
    }
    if (!b) {
        return -1;
    }
    return moment(a).isBefore(b) ? -1 : 1;
};

export const numberComparator = (a, b) => {
    if (!a) {
        return -1;
    }
    if (!b) {
        return -1;
    }
    return +a > +b ? -1 : 1;
};

export const addActionDropdown = (data, key, [first, ...rest]) => {
    return data.map(_ => ({
        ..._,
        key: _[key],
        action: (
            <Dropdown
                overlay={
                    <Menu>
                        {rest.map((action, index) => (
                            <Menu.Item key={index}>
                                <a
                                    href="javascript:void()"
                                    onClick={() => action.action(_[key])}
                                >
                                    {action.label}
                                </a>
                            </Menu.Item>
                        ))}
                    </Menu>
                }
            >
                <a
                    className="ant-dropdown-link"
                    href="javascript:void()"
                    onClick={() => first.action(_[key])}
                >
                    {first.label} <Icon type="down" />
                </a>
            </Dropdown>
        )
    }));
};

export const stringFilter = (key, value, record) =>
    record[key]
        ? record[key].toLowerCase().includes(value ? value.toLowerCase() : null)
        : false;

export const numberFilter = (key, value, record) => {
    return record[key] == value ? true : false;
};

export const numberRangeFilter = (key, range, record) => {
    if (!record[key]) {
        return false;
    }
    if (range.min && range.min >= 0 && record[key] < range.min) {
        return false;
    }
    if (range.max && range.max > 0 && record[key] > range.max) {
        return false;
    }
    return true;
};

export const dateRangeFilter = (key, range, record) => {
    if (!record[key] || !moment(record[key]).isValid()) {
        return false;
    }
    if (!range.min && range.max) {
        return moment(record[key]).isBefore(range.max);
    }
    if (range.min && !range.max) {
        return moment(record[key]).isAfter(range.min);
    }
    return moment(record[key]).isBetween(
        moment(range.min, "YYYY-MM-DD"),
        moment(range.max, "YYYY-MM-DD")
    );
};

export const customDateAndIdComparator = (a, b, type, key) => {
    const aDate = moment(a[key]);
    const bDate = moment(b[key]);

    if (aDate.isSame(bDate)) {
        if (a.id === b.id) {
            return 0;
        }
        if (a.id < b.id) {
            if (type === "ascend") {
                return -1;
            }
            return 1;
        } else {
            if (type === "ascend") {
                return 1;
            }
            return -1;
        }
    }
    if (aDate.isBefore(bDate)) {
        return -1;
    } else {
        return 1;
    }
};